import React from 'react';
import { useCssHandles } from '../../utils/functions';
import SecondLevelDesktop from './SecondLevelDesktop';
import { useSelector } from 'react-redux';
import { selectMenuState } from '../../redux/megaMenuSlice';
import FirstLevelDesktop from './FirstLevelDesktop';
import './megaMenuStyles.scss';

const CSS_HANDLES = [
	'menuContainerNav',
	'menuContainer',
	'submenuContainer',
	'submenuContainerTitle',
	'submenuList',
	'seeAllLinkContainer',
	'seeAllLink',
];
const MegaMenuHorizontal = ({
	title = 'Departments',
	blockClass = '',
	orientation,
	openOnly,
	isMobile,
	componentId,
}) => {
	const { handles } = useCssHandles('vtex-mega-menu-2-x', CSS_HANDLES, blockClass);
	const [selectedFirstLevel, setSelectedFirstLevel] = React.useState();
	const isOpenMenu = useSelector(selectMenuState);

	return (isOpenMenu && openOnly === orientation) || isMobile ? (
		<nav
			data-selection={componentId}
			className={`${handles.menuContainerNav} absolute left-0 bg-white bw1 bb b--muted-3 flex`}
		>
			<ul className={`${handles.menuContainer} list ma0 pa0 pb3 br b--muted-4 `}>
				<h3 className={`f4 fw7 c-on-base lh-copy ma0 pv5 ph5`}>{title}</h3>
				{dummyData.map((category, index) => (
					<FirstLevelDesktop
						{...{ ...category, index, blockClass, setSelectedFirstLevel }}
						isSelected={index == selectedFirstLevel}
					/>
				))}
			</ul>
			{dummyData[selectedFirstLevel] && (
				<div className={`${handles.submenuContainer} pa5 w-100`}>
					<h3 className={`${handles.submenuContainerTitle} f4 fw7 c-on-base lh-copy ma0 flex items-center mb6`}>
						{dummyData[selectedFirstLevel].name}
						<div className={`${handles.seeAllLinkContainer} t-small ml7`}>
							<a href="#" className={`${handles.seeAllLink} link underline fw7 c-on-base`}>
								Ver tudo
							</a>
						</div>
					</h3>
					<div className={`${handles.submenuList}`}>
						{dummyData[selectedFirstLevel]?.items.map((level) => {
							return <SecondLevelDesktop {...{ ...level, blockClass }} />;
						})}
					</div>
				</div>
			)}
		</nav>
	) : null;
};

export default MegaMenuHorizontal;

const dummyData = [
	{
		name: 'Categoria 1',
		items: [
			{
				name: 'Sub 1',
				items: [
					{ name: 'Terceiro nível 1' },
					{ name: 'Terceiro nível 2' },
					{ name: 'Terceiro nível 3' },
					{ name: 'Terceiro nível 4' },
					{ name: 'Terceiro nível 5' },
					{ name: 'Terceiro nível 6' },
				],
			},
			{ name: 'Sub 2' },
			{ name: 'Sub 3' },
			{ name: 'Sub 4' },
			{ name: 'Sub 5' },
			{ name: 'Sub 6' },
		],
	},
	{ name: 'Categoria 2', items: [] },
	{ name: 'Categoria 3', items: [] },
	{ name: 'Categoria 4', items: [] },
	{ name: 'Categoria 5', items: [] },
	{ name: 'Categoria 6', items: [] },
];
